import cardBg from 'assets/stamp-assets/card.png';
import Modal from 'components/Modal';
import styled from 'styled-components';

export const ModalStyled = styled(Modal)`
  /* Modal cua project set mau title o styled rieng, can specificity cao hon de doi sang trang */
  &&& .ant-modal-header {
    height: 3.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #232B3F;
  }

  &&& .ant-modal-title {
    width: 100%;
    color: #FFFFFF;
    text-align: center;
    font-family: Poppins;
    font-size: 1.625rem;
    font-weight: 600;
    letter-spacing: 0.5px;
  }
`;

export const BodyStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px;
  background: #F5F6F8;
  font-family: Poppins;
`;

export const CustomerCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  border-radius: 8px;
  background: #FFFFFF;

  .customer-info {
    display: flex;
    align-items: center;
    gap: 16px;
    overflow: hidden;
  }

  .avatar {
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #8AA9BC;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.95rem;
    font-weight: 600;
  }

  .customer-name {
    color: #1D2129;
    font-size: 2.1125rem;
    font-weight: 700;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .customer-point {
    color: #D2464F;
    font-size: 1.2188rem;
    font-weight: 700;
    line-height: 1.4;
  }

  .available-stamps {
    flex-shrink: 0;
    min-width: 140px;
    padding: 6px 16px;
    border-radius: 8px;
    background: #FDF6DD;
    text-align: center;
  }

  .available-value {
    color: #A67C1E;
    font-size: 2.4375rem;
    font-weight: 700;
    line-height: 1.2;
  }

  .available-label {
    color: #1D2129;
    font-size: 1.5844rem;
    line-height: 1.2;
  }
`;

export const StampCard = styled.div`
  width: 100%;
  max-width: 693px;
  margin: 0 auto;
  padding: 18px 24px 14px;
  border-radius: 50px;
  background-color: #101A2B;
  background-image: url(${cardBg});
  /* keo trai het khung thay vi cover, neu khong se cat mat duong vien vang o day the */
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .shop-name {
    color: #FFFFFF;
    font-size: 1.3rem;
    font-weight: 500;
    line-height: 1.3;
  }

  .card-title {
    color: #E9C877;
    font-size: 2.1125rem;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: 0.5px;
    margin-bottom: 16px;
  }

  .slot-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 24px 0;
    padding: 0 11%;
    margin-bottom: 8px;
  }

  .slot {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .slot-circle {
    width: 68px;
    height: 68px;
    border-radius: 50%;
    border: 2px dashed #D4A84C;
    display: flex;
    align-items: center;
    justify-content: center;

    &.earned {
      border: none;
    }

    /* o vua la moc thuong vua da dat: nen vang dam thay cho icon tick */
    &.reward-earned {
      border: 2px solid #E9C877;
      background: linear-gradient(135deg, #C79A3E 0%, #6E5220 100%);
    }

    .tick-icon {
      width: 68px;
      height: 68px;
    }

    .gift-icon {
      width: 28px;
      height: 28px;
    }
  }

  .slot-index {
    color: #FFFFFF;
    font-size: 1.4625rem;
    font-weight: 500;
    line-height: 1.2;
  }

  .card-footer {
    display: flex;
    align-items: center;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    padding-top: 10px;
  }

  .footer-col {
    flex: 1;

    &.footer-col-right {
      padding-left: 24px;
      border-left: 1px solid rgba(255, 255, 255, 0.2);
    }
  }

  .footer-label {
    color: #FFFFFF;
    font-size: 1.3813rem;
    line-height: 1.4;
  }

  .footer-value {
    color: #E9C877;
    font-size: 2.275rem;
    font-weight: 700;
    line-height: 1.3;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;
  /* modal dung noneBodyStyle nen antd bo het padding footer, tu chua o day */
  padding: 16px;

  button {
    flex: 1;
    white-space: nowrap;
  }
`;

export const ApplyButton = styled.button`
  height: 4.5rem;
  border-radius: 6px;
  background: #F5767F;
  color: #FFFFFF;
  font-family: Poppins;
  font-size: 1.6rem;
  font-weight: 600;

  &:disabled {
    background: #F3D0D3;
    color: #FFFFFF;
    cursor: not-allowed;
  }
`;

export const CancelRewardButton = styled.button`
  height: 4.5rem;
  border-radius: 6px;
  background: #D2464F;
  color: #FFFFFF;
  font-family: Poppins;
  font-size: 1.6rem;
  font-weight: 600;
`;

export const RewardsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: Poppins;

  .rewards-heading {
    display: flex;
    align-items: baseline;
    gap: 8px;

    .rewards-title {
      color: #1D2129;
      font-size: 1.4625rem;
      font-weight: 700;
      line-height: 1.3;
    }

    .rewards-hint {
      color: #64748B;
      font-size: 1.7062rem;
      line-height: 1.3;
    }
  }

  /* danh sach dai thi cuon rieng, footer luon nhin thay */
  .rewards-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 220px;
    overflow-y: auto;
  }

  .reward-row {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid #E5E6EB;
    background: #FFFFFF;
    text-align: left;

    &.selected {
      border-color: #2D6772;
      background: #F1F9FA;
    }

    /* mốc khách chưa đủ stamp: vẫn đọc được nhưng không chọn được */
    &.locked {
      background: #F7F8FA;
      cursor: not-allowed;
    }
  }

  .reward-radio {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid #C9CDD4;
    display: flex;
    align-items: center;
    justify-content: center;

    &.checked {
      border-color: #2D6772;
      background: #2D6772;
    }
  }

  .reward-body {
    flex: 1;
    overflow: hidden;
    /* button chi chua duoc phrasing content nen dung span, tu cho xuong dong bang display */
    display: block;
  }

  .reward-condition {
    display: block;
    color: #64748B;
    font-size: 1.5844rem;
    font-weight: 600;
    line-height: 1.3;
    text-transform: uppercase;
  }

  .reward-label {
    display: block;
    color: #1D2129;
    font-size: 1.4625rem;
    font-weight: 700;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .reward-progress {
    flex-shrink: 0;
    color: #64748B;
    font-size: 1.3rem;
    line-height: 1.3;
  }
`;

export const CloseButton = styled.button`
  height: 4.5rem;
  border-radius: 6px;
  background: #E5E6EB;
  color: #1D2129;
  font-family: Poppins;
  font-size: 1.6rem;
  font-weight: 600;
`;
